module.exports = __webpack_public_path__ + "img/img-15.d390d409.png";